import { Reveal } from "./Reveal";

const STATS = [
  { value: "12+", label: "Clinics", sub: "Multiple Locations" },
  { value: "Qualified", label: "Doctors", sub: "Experienced Professionals" },
  { value: "Two", label: "Core Specialties", sub: "Dental + Skin Care" },
  { value: "Pan-India", label: "Network", sub: "Growing Franchise Model" },
];

export function TrustBar() {
  return (
    <section data-testid="trust-bar" className="border-y border-gold/25 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-pine/5">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08} className="px-4 md:px-8 py-8 md:py-10 text-center">
              <p className="font-display text-2xl md:text-3xl font-semibold text-pine-deep">{s.value}</p>
              <p className="mt-1 text-sm font-bold text-teal-brand">{s.label}</p>
              <p className="mt-0.5 text-xs text-slate-500">{s.sub}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
